import React from 'react';

export const privateMedicalFacilityDescription = (
  <span>
    <p>
      If you received care from a private medical facility, we can get that
      information for you. We’ll ask you about that later in this application.
    </p>
    <p>
      If you received care at a VA medical facility, we have access to those
      records and can get them for you.
    </p>
  </span>
);

export const doctorDatesDecription =
  'When were you under this doctor’s care? Include the dates for the whole time you were under this doctor’s care.';

export const doctorCareDescription =
  'Please tell us where and when you were treated by a doctor.';
